import { Form, Spin } from 'antd';
import { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { validateEmail } from 'utils';
import throwException from 'utils/throwException';
import content from 'services/content';
import InputBase from 'components/Input';
import UploadFile from './UploadFile';
import './styles.scss';

interface IProps {
  t: any;
  onRef?: (r: any) => any;
  i18n: any;
  form: any;
  isCreate: boolean;
}

interface IState {
  loading: boolean;
}

class FormAddAccount extends Component<IProps, IState> {
  modalWarning: any;
  uploadFile?: UploadFile | null;

  constructor(props: IProps) {
    super(props);
    this.state = { loading: false };
  }

  componentWillUnmount() {
    const { onRef } = this.props;
    if (onRef) onRef(undefined);
  }

  shouldComponentUpdate(_nProps: IProps, nState: IState) {
    const { loading } = this.state;
    return loading !== nState.loading;
  }

  handleValidateEmail = (_, v) => {
    const { t } = this.props;
    if (v && !validateEmail(v)) {
      return Promise.reject(new Error(t('login.form.input.email.format.invalid')));
    } else {
      return Promise.resolve();
    }
  };

  isValidHttpUrl = (rule, value, callback) => {
    let url;
    const { t } = this.props;
    if (value) {
      try {
        url = new URL(value);
      } catch (_) {
        // throw new Error(t('settingPage.sosSetUp.form.require.url'));
        return Promise.reject(new Error(t('settingPage.sosSetUp.form.require.url')));
      }
      if (url.protocol !== 'http:' && url.protocol !== 'https:') {
        return Promise.reject(new Error(t('settingPage.sosSetUp.form.require.url')));
      }
    }

    return Promise.resolve();
  };

  handleOk = (values, callback) => {
    const { loading } = this.state;
    if (loading) {
      if (callback) callback(false);
      return;
    }
    const fileUpload = this.uploadFile?.validate?.();
    if (fileUpload?.error) {
      if (callback) callback(false);
      return;
    }
    content
      .create({ ...values, content_type: 'ARTICLE', file_url: fileUpload?.value || [] })
      .then(() => {
        if (callback) callback(true);
      })
      .catch((e) => {
        throwException(e);
        if (callback) callback(false);
      });
  };

  setLoading = (flag: boolean) => {
    this.setState({ loading: flag });
  };

  validateFile = () => {
    const fileUpload = this.uploadFile?.validate?.();
    return fileUpload;
  };

  render() {
    const { loading } = this.state;
    const { t, onRef, isCreate } = this.props;
    if (onRef) onRef(this);
    return (
      <Spin spinning={loading}>
        <div className="formAddAccount">
          <div className="title-modal">
            <div>
              {isCreate
                ? t('content.management.modal.create_new.title')
                : t('content.management.modal.edit.title')}
            </div>
          </div>
          <Form.Item
            rules={[
              {
                required: true,
                whitespace: true,
                message: t('content.management.modal.create_new.field.title.required'),
              },
            ]}
            name="title"
            label={t('content.management.modal.create_new.field.title')}
          >
            <InputBase
              placeholder={t('content.management.modal.create_new.field.title.placeholder')}
            />
          </Form.Item>
          <Form.Item
            rules={[
              {
                required: true,
                whitespace: true,
                message: t('content.management.modal.create_new.field.content_source_url.required'),
              },
              { validator: this.isValidHttpUrl },
            ]}
            name="source_url"
            label={t('content.management.modal.create_new.field.content_source_url')}
          >
            <InputBase
              placeholder={t(
                'content.management.modal.create_new.field.content_source_url.placeholder'
              )}
            />
          </Form.Item>
          <Form.Item shouldUpdate>
            {(props: any) => {
              const file_url = props.getFieldValue('file_url');
              return (
                <UploadFile
                  ref={(ref) => (this.uploadFile = ref)}
                  message={t('content.management.file_upload.required')}
                  required
                  setLoading={this.setLoading}
                  file_url={file_url}
                  setFieldsValue={props.setFieldsValue}
                  t={t}
                  setFields={props.setFields}
                />
              );
            }}
          </Form.Item>
        </div>
      </Spin>
    );
  }
}

export default withTranslation()(FormAddAccount);
